import { action, observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import type { Id } from '@/infra/id'
import type { ProvidedProfile } from '@/features/jobs/info-gathering/supporting-item-input'

/**
 * Props for {@link DependentsInfoSupportingItemInput}.
 */
export type DependentsInfoSupportingItemInputProps =
  ModelProps<DependentsInfoSupportingItemInput> & { type: 'DependentsInfo' }

/**
 * Supporting item input for dependents' information.
 */
export class DependentsInfoSupportingItemInput extends Model<DependentsInfoSupportingItemInput> {
  @observable.struct accessor dependents: readonly ProvidedProfile[] = []

  /**
   * Adds a dependent to the input.
   */
  @action.bound
  addDependent(dependent: ProvidedProfile) {
    this.dependents = [
      ...this.dependents.filter((d) => d.profileId !== dependent.profileId),
      dependent,
    ]
  }

  /**
   * Removes a dependent from the input.
   */
  @action.bound
  removeDependent(profileId: Id) {
    this.dependents = this.dependents.filter((d) => d.profileId !== profileId)
  }
}
